import { api } from '../../../services/api/apiClient';
import type { ApiResponse } from '../../../types/api';
import type { ChangePasswordInput, LoginResult, User } from '../types/authTypes';

export const authService = {
  login: (phone: string, password: string) => api.post<ApiResponse<LoginResult>>('/auth/login', { phone, password }).then((r) => r.data),
  logout: () => api.post('/auth/logout'),
  me: () => api.get<ApiResponse<User>>('/auth/me').then((r) => r.data),
  changePassword: (body: ChangePasswordInput) => api.post('/auth/change-password', body),
};
